import { ICellRendererParams } from "ag-grid-community";
import { ChronicBadge } from "./chronicity";
import { HccBadge } from "./hcc-badge";
import { ConditionRowData } from "./table-data";

export const ConditionCellRenderer = (params: ICellRendererParams<ConditionRowData>) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {params.data?.isHcc && <HccBadge />}
      {params.data?.isChronic && <ChronicBadge />}
      <span>{params.data?.condition}</span>
    </div>
  );
};
